import { Route, Routes } from 'react-router-dom';
import { Shell } from './components/shell/shell';
import { DicasScreen } from './screens/dicas/dicas';
import { NotFoundScreen } from './screens/not-found';
import { OnboardingScreen } from './screens/onboarding/onboarding';
import { SplashScreen } from './screens/splash/splash';
import { ValidateBoletoScreen } from './screens/validate-boleto/validate-boleto';
import { ValidatePixScreen } from './screens/validate-pix/validate-pix';
import { WelcomeScreen } from './screens/welcome/welcome';

export const App = () => {
  return (
    <Routes>
      <Route path="/" element={<SplashScreen />} />
      <Route path="/boas-vindas" element={<WelcomeScreen />} />
      <Route element={<Shell />}>
        <Route path="/onboarding" element={<OnboardingScreen />} />
        <Route path="/validar-boleto" element={<ValidateBoletoScreen />} />
        <Route path="/validar-pix" element={<ValidatePixScreen />} />
        <Route path="/dicas" element={<DicasScreen />} />
      </Route>
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};
